// @flow

export default class RangeParam<T> {
    from: T;
    to: T;

    setFrom(from: T) {
        this.from = from;
    }

    setTo(to: T) {
        this.to = to;
    }

    getFrom(): T {
        return this.from;
    }

    getTo(): T {
        return this.to;
    }
}
